<template>
  <div class="max-w-screen-xl xl:px-8 p-4 mx-auto mt-8">
    <div class="grid grid-cols-12 gap-3">
      <div
        v-for="widget in widgets"
        @click="openPreview(widget)"
        class="2xl:col-span-3 xl:col-span-3 lg:col-span-4 xs:col-span-6 col-span-12 hover:bg-gradient-to-r hover:from-green-500 hover:via-lime-500 hover:to-yellow-500 rounded-2xl hover:drop-shadow-lg p-2"
      >
        <div
          class="relative block p-4 shadow-xl rounded-xl bg-white cursor-pointer h-full"
        >
          <span
            v-if="checkTag(widget.type_explore.id) == 'hot'"
            class="absolute -right-2 -top-4 rounded-full px-2 py-1 bg-red-500 text-white font-medium text-xs"
          >
            Hot
          </span>
          <span
            v-if="checkTag(widget.type_explore.id) == 'new'"
            class="absolute -right-2 -top-4 rounded-full px-2 py-0.5 bg-success text-white font-medium text-xs"
          >
            New
          </span>
          <div class="flex items-center">
            <h2
              class="text-lg font-matter font-bold text-gray-900 line-clamp-1"
            >
              {{ widget.type_explore.title }}
            </h2>
            <img
              :src="
                'https://app.qrgateway.com/explores/' + widget.type_explore.icon
              "
              class="w-12 ml-auto"
              :alt="widget.type_explore.title"
            />
          </div>
          <p class="mt-4 sr-only">{{ widget.type_explore.description }}</p>
        </div>
      </div>
      <div
        @click="openLinkBuilder"
        class="2xl:col-span-3 xl:col-span-3 lg:col-span-4 xs:col-span-6 col-span-12 hover:bg-gradient-to-r hover:from-green-500 hover:via-lime-500 hover:to-yellow-500 rounded-2xl hover:drop-shadow-lg p-2"
      >
        <div
          class="relative block p-4 shadow-xl rounded-xl bg-white cursor-pointer h-full"
        >
          <div class="flex items-center">
            <h2
              class="text-lg font-matter font-bold text-gray-900 line-clamp-1"
            >
              Page Builder
            </h2>
            <img
              src="/icons/builder.svg"
              class="w-12 ml-auto"
              :alt="'page-builder'"
            />
          </div>
        </div>
      </div>
    </div>
    <template v-if="widget_select">
      <PreviewWidgetDialog :widget="widget_select" />
    </template>
  </div>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useQrCreateStore } from '~~/stores/qrcreate';
import PreviewWidgetDialog from '../partials/PreviewWidgetDialog.vue';

interface ExploreType {
  type_explore: {
    id: number;
    title: string;
    description: string;
    group_explore_id: number;
    icon: string;
    status: number;
    created_at: string;
    updated_at: string;
    full_widget: number;
  };
  name: string;
  image: string;
  uuid: string;
  slug: string;
}
const res = await useAsyncData(async () => {
  // TODO: Replace with actual API endpoint
  // const { data } = await $fetch('/api/widgets') or similar
  const res = [
    {
      type_explore: {
        id: 24,
        title: 'Contact Form',
        description: 'Collect visitor contact info and messages',
        group_explore_id: 5,
        icon: 'form.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Contact Form',
      image:
        'ladi/HzqbC1719534098/8tFiGT7L2xJIIpKBjBf6p1ZN7JMRlIc03O7iNbCa.png',
      uuid: '6dc177f5-cebd-45c1-8f58-1a23fcab2cc9',
      slug: '9WEmZqAI',
    },
    {
      type_explore: {
        id: 25,
        title: 'Contact Details',
        description: 'Easily share downloadable contact details',
        group_explore_id: 5,
        icon: 'contact.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Contact Details',
      image:
        'ladi/HzqbC1719534098/o9clgqqSBbrvrYmsvXRNqN60aw3N6fQiZ67pfanQ.png',
      uuid: '62db68eb-27bc-4926-a72b-26f0f2c5e777',
      slug: 'UcPLz6j1',
    },
    {
      type_explore: {
        id: 38,
        title: 'Click to Call',
        description:
          'Provide users with the fastest way to call you directly from your qrcode',
        group_explore_id: 6,
        icon: 'click_call.svg',
        status: 1,
        created_at: '2024-01-21T21:54:45.000000Z',
        updated_at: '2024-01-21T21:54:45.000000Z',
        full_widget: 0,
      },
      name: 'Click to Call',
      image:
        'ladi/HzqbC1719534098/bl8B0D468Cs0Rrx3VT7siSl7hQIUdCuFnNeO5yDU.png',
      uuid: '114c1f8a-283d-4235-96f3-fb78846b1c65',
      slug: '7f1c7aRG',
    },
    {
      type_explore: {
        id: 39,
        title: 'WhatsApp Chat',
        description:
          'Give users an opportunity to contact you on WhatsApp straight from your qrcode',
        group_explore_id: 6,
        icon: 'whatsapp.svg',
        status: 1,
        created_at: '2024-01-21T21:54:45.000000Z',
        updated_at: '2024-01-21T21:54:45.000000Z',
        full_widget: 0,
      },
      name: 'WhatsApp Chat',
      image:
        'ladi/HzqbC1719534098/rNECQSkZACnHdEQJfK1JdARs2UigprTjX1j0EEOO.png',
      uuid: 'f58ff958-8ebe-4a2f-83bf-e4e6713ca83f',
      slug: 'WkLCZD3Q',
    },
    {
      type_explore: {
        id: 40,
        title: 'Facebook Chat',
        description:
          'Allow users to contact you on Facebook Messenger from your qrcode',
        group_explore_id: 6,
        icon: 'facebook_chat.svg',
        status: 1,
        created_at: '2024-01-21T21:54:45.000000Z',
        updated_at: '2024-01-21T21:54:45.000000Z',
        full_widget: 0,
      },
      name: 'Facebook Chat',
      image:
        'ladi/HzqbC1719534098/snfdCQ8ZnoGyJzdPQMLT9lsgPob24cOgwftqecIa.png',
      uuid: '1ac79a45-7a4a-4857-b355-fcff5ba2aa4c',
      slug: 'k0D0qUsX',
    },
    {
      type_explore: {
        id: 41,
        title: 'Instagram Chat',
        description:
          'Allow users to contact you on Instagram from your website',
        group_explore_id: 6,
        icon: 'instagram_chat.svg',
        status: 1,
        created_at: '2024-01-21T21:54:45.000000Z',
        updated_at: '2024-01-21T21:54:45.000000Z',
        full_widget: 0,
      },
      name: 'Instagram Chat',
      image:
        'ladi/HzqbC1719534098/CDPv333JwOcoJgBjx1UuyPNSYJo048rYQqG6yWnr.png',
      uuid: '9cfa55f4-f52e-4eb3-9fbb-45cbfb8d466a',
      slug: '8Qv8O73O',
    },
    {
      type_explore: {
        id: 44,
        title: 'Viber Chat',
        description:
          'Let users message you on Viber directly from your website',
        group_explore_id: 6,
        icon: 'viber_chat.svg',
        status: 1,
        created_at: '2024-01-21T21:54:45.000000Z',
        updated_at: '2024-01-21T21:54:45.000000Z',
        full_widget: 0,
      },
      name: 'Viber Chat',
      image:
        'ladi/HzqbC1719534098/cQfvUMjEOhtqoc4zzUkLIVovhAyxa8pAk0k6RBni.png',
      uuid: '18018904-268e-4ab5-907d-ea16b47c2ec5',
      slug: '5xngGh2D',
    },
    {
      type_explore: {
        id: 45,
        title: 'Line Chat',
        description: 'Let users reach you out on Line right from your website',
        group_explore_id: 6,
        icon: 'line_chat.svg',
        status: 1,
        created_at: '2024-01-21T21:54:45.000000Z',
        updated_at: '2024-01-21T21:54:45.000000Z',
        full_widget: 0,
      },
      name: 'Line Chat',
      image:
        'ladi/HzqbC1719534098/ulEPSmmqCxzKd4Ly6WYWjkUSbPbUN9n07CLl91wt.png',
      uuid: '0e984e2d-c265-4756-95d5-e93a9c25a6cc',
      slug: 'CaczLiUi',
    },
    {
      type_explore: {
        id: 17,
        title: 'PayPal',
        description: 'Get paid and donation with PayPal',
        group_explore_id: 3,
        icon: 'paypal.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'PayPal',
      image:
        'ladi/HzqbC1719534098/CWQto1LZYtBN5qVtqXEuUR84smdwlcz5K6pMQbWx.png',
      uuid: '78ce5d5a-ab2c-40f4-b425-f50e95f9ff34',
      slug: 'zMKtePbU',
    },
    {
      type_explore: {
        id: 10,
        title: 'Apple Music',
        description: 'Share songs in itunes library',
        group_explore_id: 1,
        icon: 'apple-music.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Apple Music',
      image:
        'ladi/HzqbC1719534098/JUwA8MaYtS0iEaOHOSQKBfkEYB9WTdTxbUS1YEKD.png',
      uuid: '780f05bd-ab1e-4008-ab7b-2a47dfbfc23e',
      slug: 'boQ7U4if',
    },
    {
      type_explore: {
        id: 8,
        title: 'Soundcloud',
        description: 'Get your music heard on SoundCloud',
        group_explore_id: 1,
        icon: 'soundcloud.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Soundcloud',
      image:
        'ladi/HzqbC1719534098/nwhW1j8vziL0PHMM8oxkuR2nahrCn4sqV7lzFbpX.png',
      uuid: 'ac36c238-46b8-4fda-93f3-1166acd61198',
      slug: '0P8MNYNE',
    },
    {
      type_explore: {
        id: 5,
        title: 'YouTube',
        description: 'Share YouTube videos on your qr code',
        group_explore_id: 1,
        icon: 'youtube.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'YouTube',
      image:
        'ladi/HzqbC1719534098/K6Qq9PTZJ3AE101IQHNkeaaW8pOtWjwRhprsoou6.png',
      uuid: 'df54b9ff-0a05-45c4-8841-442f6454e9ec',
      slug: 'jZpLwgsQ',
    },
    {
      type_explore: {
        id: 15,
        title: 'Podcasts',
        description: 'Get more podcast listeners and subscribers',
        group_explore_id: 2,
        icon: 'podcast.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Podcasts',
      image:
        'ladi/HzqbC1719534098/HRBzjFsMEguFf0GC8aJrBoUIPhkbtPHcLVbjVExc.png',
      uuid: '03ca35db-2825-4a3c-a76f-efc73eec379e',
      slug: 'QnitSEpm',
    },
    {
      type_explore: {
        id: 16,
        title: 'Mobile App',
        description: 'Promote a mobile app & get more downloads',
        group_explore_id: 2,
        icon: 'mobile-app.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Mobile App',
      image:
        'ladi/HzqbC1719534098/ycymG5FYRoaL2SJsgas50sgKtMcW24C3SvdN1t5b.png',
      uuid: '12e94554-0be8-45dd-9603-c85b0205f680',
      slug: 'v0ejMpUr',
    },
    {
      type_explore: {
        id: 37,
        title: 'Restaurant Menu',
        description:
          'Present your dishes and drinks on your qrcode to attract more guests',
        group_explore_id: 5,
        icon: 'menu_restaurant.svg',
        status: 1,
        created_at: '2024-01-21T21:54:45.000000Z',
        updated_at: '2024-01-21T21:54:45.000000Z',
        full_widget: 1,
      },
      name: 'Restaurant Menu',
      image:
        'ladi/HzqbC1719534098/6lzflEHMGBum74Z9OneG1Ip744yz9e92kMJOIO1g.png',
      uuid: 'b43fc828-1145-4507-b494-481ba5f6d8f4',
      slug: 'VCrXMX04',
    },
    {
      type_explore: {
        id: 33,
        title: 'Event',
        description:
          'Promote your event & create calendar invites effortlessly',
        group_explore_id: 5,
        icon: 'event.svg',
        status: 1,
        created_at: '2022-11-05T18:00:32.000000Z',
        updated_at: '2022-11-05T18:00:32.000000Z',
        full_widget: 0,
      },
      name: 'Event',
      image:
        'ladi/YtzcG1669108297/nI9o3bqbB0HpQokSdbz4IBxd7zBOYqCGE6KOhGRX.png',
      uuid: 'de89a9ce-e08c-49f3-a288-421d8d7d2a40',
      slug: 'EB7m5gPQ',
    },
    {
      type_explore: {
        id: 31,
        title: 'Pdf',
        description: 'Easy sharing PDF for viewing and downloading with',
        group_explore_id: 2,
        icon: 'pdf.svg',
        status: 1,
        created_at: '2022-09-23T09:51:38.000000Z',
        updated_at: '2022-09-23T09:51:38.000000Z',
        full_widget: 0,
      },
      name: 'Pdf',
      image:
        'ladi/HzqbC1719534098/WK0SRdoOjC55Wc2jSsGLWUL2q26cOQEI1Bo0cRiy.png',
      uuid: '6cd69e4a-6ba6-456e-8431-4e13a84ba1ea',
      slug: 'dBO86LQH',
    },
    {
      type_explore: {
        id: 30,
        title: 'Google Reviews',
        description: 'Elevate trustworthiness showing real clients reviews',
        group_explore_id: 5,
        icon: 'google_review.svg',
        status: 1,
        created_at: '2022-09-21T13:51:56.000000Z',
        updated_at: '2022-09-21T13:51:56.000000Z',
        full_widget: 0,
      },
      name: 'Google Reviews',
      image:
        'ladi/YtzcG1669108297/Zatxc2mrQx9fYbiiED2dItbc6jDvfsrXWHOSMsGo.png',
      uuid: '926f1d86-5a85-4ffe-9f3a-0df9478e319f',
      slug: 'mvmlptYA',
    },
    {
      type_explore: {
        id: 42,
        title: 'Facebook Review',
        description: 'Display reviews from your Facebook page on your site',
        group_explore_id: 5,
        icon: 'facebook_review.svg',
        status: 1,
        created_at: '2024-01-21T21:54:45.000000Z',
        updated_at: '2024-01-21T21:54:45.000000Z',
        full_widget: 0,
      },
      name: 'Facebook Review',
      image:
        'ladi/HzqbC1719534098/XY1DjwFBqCugwpzC7K7ex5xdy3ugNDZPGoZM5h9V.png',
      uuid: 'e78aba17-884a-4410-aaaa-1d96b4b7228a',
      slug: 'aaGATEVC',
    },
    {
      type_explore: {
        id: 43,
        title: 'Amazon Review',
        description:
          'Share reviews about your products or store from Amazon on your site',
        group_explore_id: 5,
        icon: 'amazon_review.svg',
        status: 1,
        created_at: '2024-01-21T21:54:45.000000Z',
        updated_at: '2024-01-21T21:54:45.000000Z',
        full_widget: 0,
      },
      name: 'Amazon Review',
      image:
        'ladi/HzqbC1719534098/nNmjJWcyhLEmVtowXnF1bLXSthFLmwKwWUo145Zt.png',
      uuid: 'beed2b32-862c-47fe-bf6d-935c4812f59b',
      slug: 'vVFH1e8J',
    },
    {
      type_explore: {
        id: 29,
        title: 'Instagram',
        description: 'Attract more Instagram followers',
        group_explore_id: 1,
        icon: 'instagram.svg',
        status: 1,
        created_at: '2022-09-18T17:21:05.000000Z',
        updated_at: '2022-09-18T17:21:05.000000Z',
        full_widget: 0,
      },
      name: 'Instagram',
      image:
        'ladi/HzqbC1719534098/Oy9HpkHBf6fABHbMLq1Q4436Rqcr2IYjN3vLKh94.png',
      uuid: '921d56d2-0719-4293-9d96-92d3be06a515',
      slug: 'tWIouRax',
    },
    {
      type_explore: {
        id: 34,
        title: 'Reddit',
        description: 'Showcase your Reddit profile',
        group_explore_id: 1,
        icon: 'reddit.svg',
        status: 1,
        created_at: '2022-11-05T18:00:32.000000Z',
        updated_at: '2022-11-05T18:00:32.000000Z',
        full_widget: 0,
      },
      name: 'Reddit',
      image:
        'ladi/HzqbC1719534098/Q4znRr0AoK5W1QV7Rysq3xts2UmLzdGaPZkMTT67.png',
      uuid: '08f17e2e-97b7-4c48-b72c-21a67c15e7fb',
      slug: 'mNlaz2TS',
    },
    {
      type_explore: {
        id: 1,
        title: 'Facebook',
        description: 'Add link or Facebook like button to your qr code',
        group_explore_id: 1,
        icon: 'facebook.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Facebook',
      image:
        'ladi/HzqbC1719534098/HNiPUgmKwR4PgR4XJ2Bf7IOYM4eh8t1XqD0YBOTe.png',
      uuid: 'b2771560-4311-4c8b-ab2e-c126964696c5',
      slug: 'nfLeAMlM',
    },
    {
      type_explore: {
        id: 35,
        title: 'Image Gallery',
        description: 'Showcase NFTs you own on your qr code',
        group_explore_id: 2,
        icon: 'images.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Image Gallery',
      image:
        'ladi/HzqbC1719534098/GOFf0lLCtYN3FaPU0EienQnPbaHg9UFXarVAJkCp.png',
      uuid: '08722325-1dee-40a7-8e7d-1b3f88767b92',
      slug: 'NbvyCxKT',
    },
    {
      type_explore: {
        id: 6,
        title: 'Vimeo',
        description: 'Add Vimeo videos to your qr code',
        group_explore_id: 1,
        icon: 'vimeo.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Vimeo',
      image:
        'ladi/HzqbC1719534098/AR342s9Y6YrP0EGcvw0iv2jsihdPh5nOWQrnrGNV.png',
      uuid: 'f57e0159-2df1-4654-8bb8-9c9928a8583c',
      slug: '7w1ltURO',
    },
    {
      type_explore: {
        id: 36,
        title: 'FAQ',
        description:
          'Demonstrate the answers to the most common questions on your qrcode',
        group_explore_id: 2,
        icon: 'faq.svg',
        status: 1,
        created_at: '2024-01-21T21:54:45.000000Z',
        updated_at: '2024-01-21T21:54:45.000000Z',
        full_widget: 0,
      },
      name: 'FAQ',
      image:
        'ladi/HzqbC1719534098/JpbiahBU5bY6Ehpqv9QvwquEn5whk7cbY8RbuHx1.png',
      uuid: 'b2945b0b-1769-454c-af50-dca9d96e20de',
      slug: 'Njo5iSBM',
    },
    {
      type_explore: {
        id: 7,
        title: 'Twitch',
        description: 'Get more stream viewers and engagement',
        group_explore_id: 1,
        icon: 'twitch.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Twitch',
      image:
        'ladi/HzqbC1719534098/KBI41bU7R21KUhIn3ufjl2Sa7BNnYtW6p1ueOiNR.png',
      uuid: '61f6c992-4563-411d-bd63-4769e7c63067',
      slug: 'heXtw8eA',
    },
    {
      type_explore: {
        id: 2,
        title: 'Pinterest',
        description: 'Showcase Pins, boards and more',
        group_explore_id: 1,
        icon: 'pinterest.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Pinterest',
      image:
        'ladi/HzqbC1719534098/mpgoInJ7exXCpA4HSeYTxZUjconjTCcUWPuNcocq.png',
      uuid: '8d3ec3f3-8044-4b79-af51-a2bf987d5cee',
      slug: 'SkjpJe88',
    },
    {
      type_explore: {
        id: 4,
        title: 'Twitter',
        description: 'Showcase your tweets and Twitter feed',
        group_explore_id: 1,
        icon: 'twitter.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Twitter',
      image:
        'ladi/HzqbC1719534098/xPPpqyT615lVbV77TOAk3mamddx7wILQTupGsHsf.png',
      uuid: 'e8fa0813-533d-40f2-bc60-2ac84d5b9bfe',
      slug: 'zg0G4yxh',
    },
    {
      type_explore: {
        id: 13,
        title: 'Video',
        description: 'Upload videos and play them right',
        group_explore_id: 2,
        icon: 'video.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Video',
      image:
        'ladi/HzqbC1719534098/pcrAFGXqMPCEe0aRVgALOT85ALFOLksxOYVHKT1H.png',
      uuid: '33529105-a1fb-4686-a18c-5f53569ec126',
      slug: 'pO84pp4p',
    },
    {
      type_explore: {
        id: 9,
        title: 'Spotify',
        description: 'Share your latest or favorite music',
        group_explore_id: 1,
        icon: 'spotify.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Spotify',
      image:
        'ladi/HzqbC1719534098/FEB9Ytax5ZgdEryq8TmdH3J3ALjKMFlzM5weMpNN.png',
      uuid: 'e471a1ef-ce82-438a-8ca0-702fe6af3606',
      slug: '4U3iw2Ut',
    },
    {
      type_explore: {
        id: 12,
        title: 'Music',
        description: 'Upload music and get more streams',
        group_explore_id: 2,
        icon: 'music.svg',
        status: 1,
        created_at: '2022-09-17T02:10:51.000000Z',
        updated_at: '2022-09-17T02:10:51.000000Z',
        full_widget: 0,
      },
      name: 'Music',
      image:
        'ladi/HzqbC1719534098/6S5JDDSkmomDNC7Eh3epHImjfFUKhzLrvjYoiEEG.png',
      uuid: '9a8e9c50-3d7f-421a-b999-adb3cfefed6b',
      slug: 'xnKPuF4w',
    },
    {
      type_explore: {
        id: 32,
        title: 'File Embed',
        description: 'Display common file formats into QR Codes easily',
        group_explore_id: 2,
        icon: 'document.svg',
        status: 1,
        created_at: '2022-09-23T09:51:39.000000Z',
        updated_at: '2022-09-23T09:51:39.000000Z',
        full_widget: 0,
      },
      name: 'File Embed',
      image:
        'ladi/HzqbC1719534098/YVfNU0hoNnoR1Zg429sHYeZYoUg7nl7B4peEx8ql.png',
      uuid: 'a30985f5-f186-49ce-8929-9747b2537e3d',
      slug: 'tjG6sl4D',
    },
  ];
  return res as ExploreType[];
});
const widgets = res.data.value as ExploreType[];
const checkTag = (id: number) => {
  // New tags based on backup analysis: Click to Call, WhatsApp Chat, Facebook Chat, Instagram Chat, Viber Chat, Restaurant Menu, Facebook Review, Amazon Review, FAQ
  const news = [3, 4, 5, 6, 7, 15, 19, 20, 26];
  // Hot tags based on backup analysis: PayPal, Podcasts, Instagram
  const hots = [9, 13, 21];
  if (news.includes(id)) {
    return 'new';
  }
  if (hots.includes(id)) {
    return 'hot';
  }
  return '';
};
const { preview_widget_modal } = storeToRefs(useQrCreateStore());
const widget_select = ref<ExploreType | null>(null);
const { redirectUrl } = useUtils();
const openPreview = (widget: ExploreType) => {
  if (typeof window !== 'undefined') {
    const screen = window.innerWidth;
    if (screen < 768) {
      const url =
        'https://app.qrgateway.com/sign-up?createSample=' + widget.uuid;
      redirectUrl(url);
      return;
    }
  }
  widget_select.value = widget;
  if (widget_select.value) {
    preview_widget_modal.value = true;
  }
};

const openLinkBuilder = () => {
  redirectUrl('https://app.qrgateway.com/page-builder');
};
</script>
